require('./audio_word')
require('./create_flashcard')
require('./translate')
